// Importar los pages
// Este archivo de rutas, debe ser dinámico e incremental
import Layout from '../../layouts/Layout';
import Welcome from '../../pages/welcome/welcome';
import Validation from '../../pages/validation-content/ValidationContent';

const routesPages = [
  {
    path: '/',
    title: 'Welcome',
    layout: Layout,
    component: Welcome,
  },
  {
    path: '/validation',
    title: 'Validation',
    layout: Layout,
    component: Validation,
  }
  
];

export default routesPages;
